<section class="container routing">
    <div class="row align-items-center py-4 justify-content-center" *ngIf="form">
        <div class="col-md-12 m-auto py-4">
            <div class="container pt-4">
                <strong class="address text-center pt-5">{{'booking.add booking' |translate}}</strong>
                <div class="boxcolor rounded my-4">
                    <form [formGroup]='bookingForm' (ngSubmit)='submitoffersData(bookingForm)'>
                        <div class="row gy-3">
                            <div class="col-md-6">
                                <label for="name">{{'HealthCare.f_name' | translate}} <span
                                        class="mx-2 star">*</span></label>
                                <input type="text" id="name" class="form-control"
                                    placeholder='{{"HealthCare.f_name" | translate}}' formControlName='first_name'>
                                <div *ngIf="formOffers['first_name'].touched && formOffers['first_name'].invalid"
                                    class="text-danger">
                                    <div
                                        *ngIf="formOffers['first_name'].errors && formOffers['first_name'].errors['required']">
                                        {{"Login.required" | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label for="last_name">{{'HealthCare.L_name' | translate}} <span
                                        class="mx-2 star">*</span></label>
                                <input type="text" id="last_name" class="form-control"
                                    placeholder='{{"HealthCare.L_name" | translate}}' formControlName='last_name'>
                                <div *ngIf="formOffers['last_name'].touched && formOffers['last_name'].invalid"
                                    class="text-danger">
                                    <div
                                        *ngIf="formOffers['last_name'].errors && formOffers['last_name'].errors['required']">
                                        {{"Login.required" | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label>{{'services.services' | translate}} <span class="mx-2 star">*</span></label>
                                <fieldset (click)="focusField()" class="form-control"
                                    (change)="onChangeService($event)">
                                    <select class="text-muted listBox" #item (change)="getNewSubService(item.value)"
                                        placeholder="city">
                                        <option hidden [ngValue]="null">{{'services.services' | translate}}</option>
                                        <option *ngFor="let service of services  ; let i = index" [value]="service.id">
                                            {{this.currentLang.source._value == 'en' ? service.en_name :
                                            service.ar_name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>

                            <div class="col-md-6">
                                <label>{{"services.sub service Name" | translate}} <span
                                        class="mx-2 star">*</span></label>
                                <fieldset (click)="focusField()" class="form-control" (change)="onChange($event)"
                                    [disabled]="isDisabledService">
                                    <select class="text-muted select listBox" placeholder="sub service" #newItem
                                        (change)="getSubServicewithSub(newItem.value)">
                                        <option hidden [ngValue]="null">{{"services.sub service Name" | translate}}
                                        </option>
                                        <option *ngFor="let details of newServices  ; let i = index"
                                            [value]="details.id">
                                            {{this.currentLang.source._value == 'en' ? details.sub_servie_en_name :
                                            details.sub_servie_ar_name}}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>

                            <div class="col-md-6">
                                <label>
                                    {{"services.service name" | translate}}
                                </label>
                                <fieldset (click)="focusField()" [disabled]="isDisabled" class="form-control">
                                    <select class="text-muted listBox" [(ngModel)]="selectedHealthCareId" #itemHC
                                        (change)="onHealthCareChange($event)" (change)="getHCId(itemHC.value)">
                                        <option value="" hidden>{{'services.service name' | translate}}</option>
                                        <option *ngFor="let details of serviceDetails" [value]="details.health_care_id">
                                            {{ currentLang.source._value == 'en' ? details.health_care_en_name :
                                            details.health_care_ar_name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>
                            <div class="col-md-6">
                                <label>{{"branches.branches" | translate}}</label>
                                <fieldset (click)="focusField()" class="form-control" [disabled]="branchDisabled">
                                    <select class="text-muted listBox" (change)="onChangeBranch($event)"
                                        formControlName="branch_id" #branchId>
                                        <option value="" hidden>{{'branches.branches' | translate}}</option>
                                        <option *ngFor="let branch of allBranches" [value]="branch.branch_id">
                                            {{ currentLang.source._value == 'en' ? branch.branch_en_name :
                                            branch.branch_ar_name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>

                            <div class="col-md-6">
                                <label for="Telephone Number">{{"booking.subservicebyhc" | translate}}</label>
                                <fieldset (click)="focusField()" class="form-control" [disabled]="serviceDisabled">
                                    <select class="text-muted listBox" #serviceId
                                        (change)="serviceAvailabilityId(serviceId.value)"
                                        formControlName='service_availability_id'>
                                        <option value="" hidden>{{'booking.subservicebyhc' | translate}}</option>
                                        <option *ngFor="let branch of subSubServices"
                                            [value]="branch.service_availability_id">
                                            {{ currentLang.source._value == 'en' ? branch.sub_sub_service_en_name :
                                            branch.sub_sub_service_ar_name }}
                                        </option>
                                    </select>
                                </fieldset>
                            </div>

                            <div class="col-md-6">
                                <label for="Telephone Number">{{'Register.Telephone Number' | translate}}<span
                                        class="mx-2 star">*</span></label>
                                <input type="text" id="Telephone Number" class="form-control" placeholder="5XXXXXXXX"
                                    formControlName='phone_number'>
                                <div *ngIf="formOffers['phone_number'].touched && formOffers['phone_number'].invalid"
                                    class="text-danger">
                                    <div
                                        *ngIf="formOffers['phone_number'].errors && formOffers['phone_number'].errors['required']">
                                        {{"Login.required" | translate}}
                                    </div>

                                    <div
                                        *ngIf="formOffers['phone_number'].errors && formOffers['phone_number'].errors['pattern']">
                                        {{"booking.error" | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <form [formGroup]='codeForm' (ngSubmit)='sendCode(codeForm)'>
                                    <label>{{'offers.code' | translate}} <span class="mx-2 star">*</span> </label>
                                    <mat-form-field appearance="outline">
                                        <input matInput [disabled]="disabledFields" formControlName="code"
                                            class="form-control">
                                        <mat-icon matSuffix>
                                            <button [disabled]="disabledFields" class="btn btn-codes btn-primary">
                                                {{'Login.send' | translate}}
                                            </button>
                                        </mat-icon>
                                    </mat-form-field>
                                    <div *ngIf="formOffers['code'].touched && formOffers['code'].invalid"
                                        class="text-danger">
                                        <div *ngIf="formOffers['code'].errors && formOffers['code'].errors['required']">
                                            {{"Login.required" | translate}}
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div class="col-md-6">
                                <label>{{'services.price' | translate}}</label>
                                <div class="mb-3">
                                    <input hidden class="form-control" id="price"
                                        placeholder='{{"services.new price" | translate}}' type="number">
                                    <span class="px-2 form-control py-3">
                                        {{price}}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </form>


                    <div class="d-flex justify-content-end">

                        <button class="btn commonButton my-3" [disabled]="DisabledButton"
                            (click)='submitoffersData(bookingForm)' type="submit">
                            <i class='fas fa-spinner fa-spin' *ngIf="isLoading"></i>
                            <span *ngIf="!isLoading">{{"Login.send" | translate}}</span>
                        </button>

                        <button class="btn btn-success m-3" (click)="resetForm()" type="submit">
                            <span>{{"Login.reset" | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="getpaid">
        <div class="d-flex">
            <div (click)="newBooking()">
                <img *ngIf="this.currentLang.source._value == 'ar'" src="assets/images/next.png"
                    class="showDetails mx-3 mt-1" alt="see more">
                <img *ngIf="this.currentLang.source._value == 'en'" src="assets/images/iconarr.png"
                    class="showDetails mx-3 mt-1" alt="see more">
            </div>
            <h1 class="fw-bolder text-muted">{{"payment.paymentMethod" |translate}}</h1>
        </div>
        <div class="d-flex justify-content-evenly flex-wrap payment-methods mt-3">
            <div class="mt-2 box-payment d-flex justify-content-center align-items-center text-center"
                *ngFor="let method of Initiated" (click)="excutePaid($event , method.PaymentMethodId)"
                data-bs-target="#url" data-bs-toggle="modal">
                <div>
                    <img src="{{method.ImageUrl}}" alt="payment method">
                    <p class="text-center pt-2">{{this.currentLang.source._value == 'en' ?
                        method.PaymentMethodEn :
                        method.PaymentMethodAr}}</p>
                </div>
            </div>
        </div>

        <div class="modal fade" id="url" tabindex="-1" aria-labelledby="urlLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="close p-2">
                            <img src="assets/images/closemenu.png" data-bs-dismiss="modal" aria-label="Close"
                                class="closeMenu" alt="close">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex justify-content-evenly flex-wrap">
                            <a href="{{excuted.PaymentURL}}" target="_blank">
                                <button class="btn btn-primary w-100 my-4">
                                    {{"payment.paid" |translate}}
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>